import React from "react";
import { Component, MouseEvent } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";

import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";

import { Translate } from "../../helpers/Translate";
import { actionCreators as ParentCreators } from "../../store/Parent";

// Layout
import DashBoardNav from "./DashBoardNavComponent";
import SideNav from "./SideNavComponent";
import Breadcrumbs from "./Breadcrumbs";
import "./DashBoard.css";

// Parent
import Home from "../Parent/parentpages/Home/Home";
import ViewProfile from "../Parent/parentpages/ViewProfile";
import EditProfile from "../Parent/parentpages/EditProfile";
import ChangePassword from "../Parent/parentpages/ChangePassword";
import ProfileMenu from "../Parent/parentpages/ProfileMenu";
import ParentMenu from "../Parent/parentpages/ParentMenu";
import ParentCard from "../Parent/parentpages/ParentCard";
import ChatBody from "../Parent/parentpages/chatBody/ChatBody";
import ChatList from "../Parent/parentpages/chatList/ChatList";
import ChatContent from "../Parent/parentpages/chatContent/ChatContent";

// Finance
import DoPayment from "../Fees/pages/DoPayment";
import Payments from "../Fees/pages/Payments";
import Subscriptions from "../Fees/pages/Subscriptions";
import Finance from "../Parent/Finance";
import Schoolfees from "../Parent/Schoolfees";
import Installments from "../Installments/Installments";
import EWallet from "../Students/ewallet";
import Transactions from "../Students/ewallet_Transactions";

// Students
import ViewStudents from "../Students/ViewStudents";
import ViewStudent from "../Students/ViewStudent";
import ProgressReport from "../Students/StudentProgress";
import MapGrowth from "../Students/MapGrowth/MapGrowth";
import ReinforcementsDetails from "../Students/ReinforcementDetails";
import ClassActivities from "../Students/dailyactivities/DailyActivities";

// Attendance
import LateArrival from "../Students/LateArrival/LateArrival";
import EarlyDismissal from "../Students/earlydismissal/EarlyDismissal";
import ExcusesTables from "../Students/Excuses/ExcusesTable";

// Meetings
import Meetings from "../Students/Meetings/Meetings";
import GroupMeetings from "../Students/Meetings/GroupMeetings";
import GroupMeetingSlots from "../Students/Meetings/GroupMeetingSlots";

// Student life
import AcademicInterventions from "../Students/AcademicInterventions/AcademicInterventions";
import Intervention from "../Students/interventions/interventions";
import InterventionDetails from "../Students/interventions/interventionDetails";
import ClinicVisits from "../Students/clinicvisits/clinicvisits";
import ClinicVisitDetails from "../Students/clinicvisits/clinicvisitdetails";
import WallOfLove from "../Students/WallOfLove/WallOfLove";
import Resturant from "../Students/Resturant/Resturant";
import Cafeteria from "../Students/Resturant/Cafeteria";
import CafeteriaMenu from "../Students/Resturant/Menu";
import ServiceSubscription from "../Parent/ServiceSubscription";

const mapDispatchToProps = (dispatch: (arg0: any) => any) => ({
  GetParent: (data: any) => dispatch(ParentCreators.GetParent(data)),
  SaveToken: (data: any) => dispatch(ParentCreators.SaveToken(data)),
});

function mapStateToProps(state: any) {
  return {
    guardian: state.Parent.guardian,
  };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

/**
 * Authenticated dashboard shell: top nav, side nav, page header and the
 * routes of every dashboard page (mounted under /dashboard/*).
 */
class DashBoard extends Component<any, any> {
  state: any;
  t = new Translate();

  /** Collapses / expands the side navigation. */
  toggleSideBar(event: MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    $("body").toggleClass("sb-sidenav-toggled");
  }

  userDropdown(event: MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    $("#privateuserMenu").toggleClass("show");
  }

  componentDidMount() {
    // Hide the full-page loader rendered by index.html
    $("#preloader").hide();
  }

  render() {
    return (
      <React.Fragment>
        <DashBoardNav
          Logout={this.props.Logout}
          toggleSideBar={this.toggleSideBar}
          userDropdown={this.userDropdown}
        />

        <div id="layoutSidenav">
          <SideNav />

          <div id="layoutSidenav_content">
            <main className="container-fluid">
              <Breadcrumbs />

              <Routes>
                {/* Payments */}
                <Route path="/dopayment" element={<DoPayment />} />
                <Route path="/payments" element={<Payments />} />
                <Route path="/subscriptions" element={<Subscriptions />} />

                {/* Chat */}
                <Route path="/chatbody" element={<ChatBody />} />
                <Route path="/chatlist" element={<ChatList />} />
                <Route path="/chatcontent" element={<ChatContent />} />

                {/* Parent profile */}
                <Route path="/viewprofile" element={<ViewProfile />} />
                <Route path="/editprofile" element={<EditProfile />} />
                <Route path="/changepassword" element={<ChangePassword />} />
                <Route path="/profilemenu" element={<ProfileMenu />} />
                <Route path="/parentmenu" element={<ParentMenu />} />
                <Route path="/parentcard" element={<ParentCard />} />

                {/* Finance (Smart Wallet and its sections) */}
                <Route path="/finance" element={<Finance />} />
                <Route path="/finance/ewallet" element={<EWallet />} />
                <Route
                  path="/finance/ewallet/transaction/:id"
                  element={<Transactions />}
                />
                <Route path="/finance/schoolfees" element={<Schoolfees />} />
                <Route
                  path="/finance/servicesubscription"
                  element={<ServiceSubscription />}
                />
                <Route path="/installments" element={<Installments />} />

                {/* Students */}
                <Route path="/viewstudents" element={<ViewStudents />} />
                <Route path="/viewstudents/:id" element={<ViewStudent />} />
                <Route
                  path="/viewstudents/:id/progress-report"
                  element={<ProgressReport />}
                />
                <Route
                  path="/viewstudents/:id/map-growth"
                  element={<MapGrowth />}
                />
                <Route
                  path="/viewstudents/:id/Reinforcement-point"
                  element={<ReinforcementsDetails />}
                />
                <Route
                  path="/classactivities/:id"
                  element={<ClassActivities />}
                />

                {/* Attendance */}
                <Route path="/latearrival" element={<LateArrival />} />
                <Route path="/earlydismissal" element={<EarlyDismissal />} />
                <Route path="/excuses" element={<ExcusesTables />} />

                {/* Meetings */}
                <Route path="/meetings" element={<Meetings />} />
                <Route path="/meetings/:id" element={<Meetings />} />
                <Route path="/groupmeetings" element={<GroupMeetings />} />
                <Route
                  path="/groupmeetings/:id"
                  element={<GroupMeetingSlots />}
                />

                {/* Student life */}
                <Route
                  path="/academicinterventions"
                  element={<AcademicInterventions />}
                />
                <Route path="/interventions" element={<Intervention />} />
                <Route
                  path="/interventions/:id"
                  element={<InterventionDetails />}
                />
                <Route path="/clinicvisits" element={<ClinicVisits />} />
                <Route
                  path="/clinicvisits/:id"
                  element={<ClinicVisitDetails />}
                />
                <Route path="/walloflove" element={<WallOfLove />} />
                <Route path="/resturant" element={<Resturant />} />
                <Route path="/cafeteria" element={<Cafeteria />} />
                <Route path="/cafeteriaMenu" element={<CafeteriaMenu />} />

                {/* Fallback */}
                <Route path="*" element={<Home />} />
              </Routes>
            </main>

            <footer className="pp-footer py-4 bg-light mt-auto">
              <div className="container-fluid">
                <div className="d-flex align-items-center justify-content-between small">
                  <div>Copyright &copy; IVY 2020</div>
                  <div className="pp-footer-links">
                    <a id="Privacy" href="#Privacy">
                      Privacy Policy
                    </a>
                    <a id="Terms" href="#Terms">
                      Terms &amp; Conditions
                    </a>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connector(DashBoard);
